import * as React from "react";
import { useCallback } from "react";
import capitalize from "lodash/capitalize";
import { useTranslation } from "react-i18next";
import fixup from "views/pages/StyleFixups.css";
import { Col, Row } from "components/bootstrap";
import PageContentLayout from "components/layout/PageContentLayout";
import mergeParameterValues from "enterprise/parameters/logic/mergeParameterValues";
import ParameterInputForm from "./ParameterInputForm";
const KNOWN_VIEW_TYPES = ["dashboard", "search"];
const RequiredParametersForViewForm = ({
  onSubmit = () => {
  },
  parameters,
  view: { type, title, search },
  executionState
}) => {
  const { t } = useTranslation("enterprise_common");
  const viewTypeKey = type == null ? void 0 : type.toLowerCase();
  const viewType = KNOWN_VIEW_TYPES.includes(viewTypeKey) ? t(`parameters.view_types.${viewTypeKey}`) : capitalize(type);
  const _onSubmit = useCallback(
    (newValues) => {
      const newExecutionState = mergeParameterValues(newValues, executionState);
      return onSubmit({ executionState: newExecutionState });
    },
    [executionState, onSubmit]
  );
  return /* @__PURE__ */ React.createElement(PageContentLayout, null, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 8, mdOffset: 3, className: fixup.bootstrapHeading }, /* @__PURE__ */ React.createElement("h1", null, viewType, ": ", /* @__PURE__ */ React.createElement("em", null, title)), /* @__PURE__ */ React.createElement("p", null, t("parameters.required_form.description", { viewType }))), /* @__PURE__ */ React.createElement(ParameterInputForm, { parameters, searchId: search.id, onSubmit: _onSubmit })));
};
export default RequiredParametersForViewForm;
